// extracted by mini-css-extract-plugin
export var equalColumn = "_gk-0";